'use strict';

var Configuration = {
  BaseUrl: "https://localhost:44362"
};
export default Configuration;